import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { BACKEND_URL } from '../lib/api';

const API = BACKEND_URL;

/**
 * VisitTracker
 * ------------
 * Fires a `POST /api/marketing/track-visit` for every public-site
 * route change. We deliberately skip `/app/*`, `/ip-logs`, and any
 * authenticated areas so we only collect public marketing traffic.
 */
export default function VisitTracker() {
  const { pathname } = useLocation();
  const lastTracked = useRef('');

  useEffect(() => {
    // Public-site only (and never /ip-logs to keep that dashboard invisible)
    const skipPrefixes = [
      '/app',
      '/ip-logs',
      '/sales-order',
      '/dispatch',
      '/customers',
      '/cobranding',
      '/products',
      '/batches',
      '/qc',
      '/transformations',
      '/planner',
      '/templates',
      '/pallet-labels',
      '/reports',
      '/supplier-codes',
      '/supplier-trace',
      '/profile',
      '/users',
      '/settings',
      '/backup',
      '/deleted-items',
      '/admin',
      '/account',
      '/quick-order',
      '/dispatch-view',
    ];
    if (skipPrefixes.some((p) => pathname === p || pathname.startsWith(p + '/'))) {
      return;
    }
    if (pathname === lastTracked.current) return;
    lastTracked.current = pathname;

    // Fire and forget, never break the UI if this call fails
    try {
      axios.post(
        `${API}/api/marketing/track-visit`,
        {
          path: pathname,
          referrer: document.referrer || '',
          title: document.title || '',
        },
        { timeout: 4000 },
      ).catch(() => {});
    } catch {
      // ignore
    }
  }, [pathname]);

  return null;
}
